'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require('../util');

exports.default = {
  createRequest: function createRequest(api, data) {
    var fragment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
    var bookingAction = arguments[3];

    var fields = {
      'app': '',
      'availabilitySlot': '',
      'date': '',
      'name': '',
      'lastName': '',
      'phoneNumber': '',
      'email': '',
      'people': '',
      'restaurant': '',
      'type': ''
    };

    var args = Object.assign({}, fields, data);
    args['type'] = (0, _util.serializeEnum)(args['type']);

    if (args['sourceType']) {
      args['sourceType'] = (0, _util.serializeEnum)(args['sourceType']);
    }

    var query = 'mutation { createBookingRequest(' + (0, _util.serializeForMutation)(args) + ') { ' + fragment + ' } }';

    var queryName = 'createBookingRequest';
    return (0, _util.wrapAction)(bookingAction, queryName, 'createRequest', api.fetch(query, {}, queryName));
  },
  loadBookingAvailability: function loadBookingAvailability(api, appId, _ref, bookingAction) {
    var from = _ref.from,
        to = _ref.to;

    var query = '{\n      app(id: "' + appId + '") {\n        bookingRushes(removeExpired:true) {\n          id\n          message\n          targetDate\n          expirationDate\n          restaurants {\n            restaurant {\n              id\n            }\n            slots {\n              open\n              totalSpots\n              availableSpots\n            }\n          }\n          constraints {\n            maxPeople\n          }\n          voucher {\n            id\n            validityPeriod {\n              from\n              to\n            }\n            active\n            discount {\n              amount\n              format\n            }\n            message\n          }\n      \t}\n\n        merchant {\n          restaurants {\n            id\n            bookingAvailability(from: "' + from + '" to: "' + to + '") {\n              day\n              date\n              open\n              slots {\n                open\n                close\n                totalSpots\n                availableSpots\n              }\n            }\n          }\n        }\n      }\n    }';

    var queryName = 'loadBookingAvailability';
    return (0, _util.wrapAction)(bookingAction, 'app[0]', 'loadBookingAvailability', api.fetch(query, {}, queryName));
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/service/booking.js
// module id = 202
// module chunks = 0